
import { 
  Home, 
  DollarSign, 
  FileText, 
  Receipt, 
  Building2, 
  User, 
  Calculator, 
  MapPin,
  CreditCard
} from "lucide-react";

export const mainLinks = [
  { path: "/", icon: Home, label: "Dashboard" },
  { path: "/payments", icon: DollarSign, label: "Pagos" },
  { path: "/readings", icon: FileText, label: "Lecturas" },
  { path: "/expenses", icon: Receipt, label: "Gastos" },
  { path: "/house", icon: Building2, label: "Mi casa" },
  { path: "/plot", icon: MapPin, label: "Mi parcela" },
];

export const toolLinks = [
  { path: "/calculator", icon: Calculator, label: "Calculadora gasto" },
  { path: "/payment-creation", icon: CreditCard, label: "Creación de cobro" },
];

export const profileLinks = [
  { path: "/profile", icon: User, label: "Mi perfil" },
];
